// extracted by mini-css-extract-plugin
module.exports = {"card":"card-styles-module--card--223PQ","title":"card-styles-module--title--YD-Fq","close":"card-styles-module--close--2iSZL","body":"card-styles-module--body--xJigB"};